import { WEBSITE_BASE_URL } from "@/constants";

export default function Home() {
  window.location.replace(WEBSITE_BASE_URL);
  return null;
}
